/*
 * Dockside product page: the image counter on small screens and the lightbox.
 */
(() => {
  if (customElements.get('dsi-gallery')) return;

  class DsiGallery extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelector('[data-slides]');
      this.openers = Array.from(this.querySelectorAll('[data-full]'));
      this.dialog = this.querySelector('dialog');
      this.image = document.createElement('img');
      this.image.className = 'dsi-lightbox__image';
      this.querySelector('[data-lightbox-close]').append(this.image);
      this.indexLabel = this.querySelector('[data-index]');
      this.current = 0;
      this.raf = null;

      this.openers.forEach((opener, index) => {
        opener.addEventListener('click', () => this.open(index));
      });
      this.dialog.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('keydown', (event) => this.onKeydown(event));
      this.dialog.addEventListener('close', () => this.onClose());

      if (this.indexLabel) {
        this.slides.addEventListener('scroll', () => this.onScroll(), { passive: true });
      }
    }

    open(index) {
      this.show(index);
      this.dialog.showModal();
      document.documentElement.classList.add('dsi-locked');
    }

    show(index) {
      this.current = (index + this.openers.length) % this.openers.length;
      const opener = this.openers[this.current];
      this.image.src = opener.dataset.full;
      this.image.alt = opener.dataset.alt;
    }

    onKeydown(event) {
      if (event.key === 'ArrowRight') this.show(this.current + 1);
      if (event.key === 'ArrowLeft') this.show(this.current - 1);
    }

    onClose() {
      document.documentElement.classList.remove('dsi-locked');
      this.openers[this.current].focus();
    }

    onScroll() {
      if (this.raf !== null) return;
      this.raf = window.requestAnimationFrame(() => {
        this.raf = null;
        const items = this.slides.children;
        const step = items[1].offsetLeft - items[0].offsetLeft;
        this.indexLabel.textContent = Math.round(this.slides.scrollLeft / step) + 1;
      });
    }
  }

  customElements.define('dsi-gallery', DsiGallery);
})();
